export enum BehaviorCodesListColumns {
  REDORDER = 'Reorder',
  ORDER = 'Order',
  CODE = 'Code',
  DESCRIPTION = 'Description',
  DISTRICT_CODE = 'District Code',
  SCHOOL = 'School',
  PRINT_PASS = 'Print Pass',
  ACTIVE = 'Active',
  ACTIONS = 'Actions',
}
